
import React from 'react'
import "./footer.css"
import { APP_NAME } from '../constants'

function Footer() {
    return (
        <div className='footer-container'>
            <div className='d-flex flex-column align-items-center'>
                <div className='app-header'>
                    <img className='footer-image' src="/images/kitchen-logo.png" />
                    <span className='footer-title ms-3'>{APP_NAME}</span>
                </div>
                <p className='footer-desc'>The only thing we are serious about is food.</p>
                <p className='footer-desc'>Contact us on</p>
                <div className='contact-us-icons-container'>
                    <i class="fa-brands fa-facebook"></i>
                    <i class="fa-brands fa-facebook-messenger"></i>
                    <i class="fa-brands fa-square-instagram"></i>
                    <i class="fa-brands fa-square-twitter"></i>
                </div>
            </div>
        </div>
    )
}

export default Footer